import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";

import AugmontEditForm from "./AugmontEditForm";

// Once the Augmont list API is available, replace the placeholder body below
// with a table (mirroring BatukProducts) and put an Edit IconButton on each
// row that calls handleOpenEdit(product) with the real record instead of
// the sample data used here.
export default function AugmontProducts() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);

  const handleOpenEdit = (record) => {
    setEditingRecord(record);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setEditingRecord(null);
  };

  const handleFormSubmit = (payload) => {
    // TODO: replace with the real update API call once available.
    console.log("Update Augmont record:", payload);
    handleCloseDialog();
  };

  return (
    <Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Typography variant="h6" fontWeight={600}>
          Augmont Products
        </Typography>
        {/* Temporary manual trigger until the list API + per-row Edit buttons exist */}
        <Button
          variant="outlined"
          startIcon={<EditIcon />}
          onClick={() => handleOpenEdit(null)}
        ></Button>
      </Stack>

      <Dialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <IconButton
          onClick={handleCloseDialog}
          sx={{ position: "absolute", top: 8, right: 8, zIndex: 1 }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{ p: 0 }}>
          <AugmontEditForm data={editingRecord} onSubmit={handleFormSubmit} />
        </DialogContent>
      </Dialog>
    </Box>
  );
}
